export const PLAN = `
	id
  name
  baseCost
  messageCost
  period
  messageLimit
`
